<template>
  <w-modal v-model="open" type="danger">
    <h1 slot="header">取消一起訂？</h1>
    <div slot="content" class="content">
      <h2 class="content__title">{{ order.name }}</h2>
      <b-field horizontal label="店名">{{ order.store_name }}</b-field>
      <b-field horizontal label="菜單" class="mb-6">{{ order.menu_name }}</b-field>
      <b-field horizontal label="訂購開始時間">
        {{ humanizeTime(order.start_time) }} - {{ humanizeTime(order.end_time) }}
      </b-field>
      <b-field label="目前進度">
        <div class="columns">
          <div class="column order-info-column">
            <h3>目前已訂購人數</h3>
            <h4>{{ order.report?.ordered_member_count || 0 | commaFormat }}</h4>
          </div>
          <div class="column order-info-column">
            <h3>已付費金額</h3>
            <h4>${{ order.report?.ordered_total || 0 | commaFormat }}</h4>
          </div>
        </div>
      </b-field>
    </div>
    <div slot="footer">
      <b-button
        type="is-ghost"
        class="cancel-button"
        :disabled="loading"
        @click="open = false">
        返回
      </b-button>
      <b-button
        type="is-danger"
        class="ml-2"
        :disabled="loading"
        @click="onConfirm">
        {{ loading ? '載入中⋯' : '取消一起訂' }}
      </b-button>
    </div>
  </w-modal>
</template>

<script>
import CancelConfirmation from './CancelConfirmation';

export default CancelConfirmation;
</script>

<style lang="scss" scoped>
@import 'CancelConfirmation';
</style>
